import type { Contact } from "@/features/contact/types";

export const getContactFullName = (contact: Contact) => {
  if (!contact.firstName?.split("") && !contact.lastName?.split("")) {
    return contact.phone;
  }

  if (contact.firstName && contact.lastName) {
    return `${contact.firstName} ${contact.lastName}`.trim();
  }

  return contact.firstName || contact.lastName;
};

export const getContactDisplayName = (contact: Contact): string => {
  return (
    getContactFullName(contact) || contact.phone || contact.email || "Unknown"
  );
};
